import React from 'react';
import './BoardPatrons.css';

const BoardPatrons = () => {
  const patrons = [
    {
      name: 'HRH. King Alfred Diete Spiff',
      title: 'Former Military Governor of Rivers State & Amayanabo of Twon-Brass',
      image: '/images/king-alfred-diete-spiff.jpg',
      bio: 'His Royal Majesty, King Alfred Papapreye Diete-Spiff, is a pioneer military governor and a first-class traditional ruler. He was appointed the first Military Governor of Rivers State in 1967 at the young age of 25, serving until 1975. During his tenure, he initiated several key developmental programs, including establishing the College of Science and Technology (now a university) and the University of Port Harcourt. A former naval officer who trained at the Royal Naval College, he has been the Amayanabo of Twon-Brass since 1978. He has also served as Chancellor of several universities and holds the national honor of OFR.'
    },
    {
      name: 'HRH. Sidi Dauda Bage, Emir Of Lafia',
      title: 'Justice of the Supreme Court of Nigeria & Emir of Lafia',
      image: '/images/sidi-dauda-bage.jpg',
      bio: 'His Royal Highness, Justice Sidi Dauda Bage, is a traditional ruler with a distinguished legal career. He was selected as the Emir of Lafia in Nasarawa State in 2019 after the passing of the previous Emir. Before ascending to the throne, he served as a Justice of the Supreme Court of Nigeria. Born in Lafia in 1956, he attended Ahmadu Bello University and the Nigerian Law School, being called to the bar in 1981.'
    },
    {
      name: 'HE Faruk Malami Yabo, MFR',
      title: 'Ambassador to Jordan & Former Commissioner, Sokoto State',
      image: '/images/Faruk-Malami-Yabo.png',
      bio: 'His Excellency, Faruk Malami Yabo, is a politician, entrepreneur, and diplomat. He currently serves as Nigeria\'s Ambassador Extraordinary and Plenipotentiary to the Hashemite Kingdom of Jordan. He previously served as the Honorable Commissioner for Finance and later for Local Government and Community Development in Sokoto State. A recipient of the national honor MFR, he has also studied at Harvard University\'s Kennedy School of Government.'
    },
    {
      name: 'HRM Eze Prof. Dele Amuzienwa Odigbo',
      title: 'Chairman, ISOPADEC & AICIS Patron',
      image: '/images/dele-amuzienwa-odigbo.jpg',
      bio: 'HRM Eze Prof. Dele Amuzienwa Odigbo serves as the Chairman of the Imo State Oil Producing Areas Development Commission (ISOPADEC). He became a Patron of the Africa Infrastructure, Climate Change & Investment Summit (AICIS) 2023 Exhibition scheduled for Washington, DC, USA. His leadership focuses on oil-producing communities and sustainable development in the Niger Delta region.'
    }
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Board of Patrons</h1>
        <p>Our distinguished patrons</p>
      </section>

      <section className="patrons-page-section">
        <div className="container">
          <div className="patrons-page-list">
            {patrons.map((patron, index) => (
              <div className="patron-page-card" key={index}>
                <div className="patron-page-image" style={{backgroundImage: `url(${patron.image})`}}></div>
                <div className="patron-page-info">
                  <h3>{patron.name}</h3>
                  <p className="patron-title">{patron.title}</p>
                  <p className="patron-bio">{patron.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BoardPatrons;